import { render, staticRenderFns } from "./TableBanksAccounts.vue?vue&type=template&id=c65006b2"
import script from "./TableBanksAccounts.vue?vue&type=script&lang=js"
export * from "./TableBanksAccounts.vue?vue&type=script&lang=js"
import style0 from "./TableBanksAccounts.vue?vue&type=style&index=0&id=c65006b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports